import React, { useEffect, useState } from "react";
import { getCompletionAlertDetails } from "../../../services/AppService";
import { useNavigate } from "react-router-dom";
import PageFade from "../../../components/Login/PageFade";
import closeButton from '../../../assets/images/close.png';
import { resolveMediaUrl } from "../../../utility/media";
import { useTranslation } from "react-i18next";

const CompletionAlertDetailsPage = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => { fetchDetails(); }, []);

    const fetchDetails = async () => {
        setLoading(true);
        try {
            const data = await getCompletionAlertDetails();
            setItems(data.content || []);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <PageFade>
            <div className="bg-white shadow-lg rounded-2xl p-6">
                <div className="flex justify-between items-center border-b pb-3 mb-4">
                    <h4 className="text-xl font-semibold text-blue">{t('pageTitles.issuedCompletion')}</h4>
                    <img src={closeButton} className="w-6 h-6 cursor-pointer" onClick={() => navigate(-1)} alt="close" />
                </div>

                <div className="overflow-x-auto">
                    <table className="w-full border text-sm ctable text-center border-collapse">
                        <thead>
                            <tr className="bg-[#a0adf1] text-white">
                                <th className="p-3 border border-gray-400 w-12">{t('tables.srNo')}</th>
                                <th className="p-3 border border-gray-400 text-left">{t('work.workName')}</th>
                                <th className="p-3 border border-gray-400">{t('work.tenderId')}</th>
                                <th className="p-3 border border-gray-400">{t('work.workOrderNo')}</th>
                                <th className="p-3 border border-gray-400">{t('work.duration')}</th>
                                <th className="p-3 border border-gray-400">{t('work.orderDate')}</th>
                                <th className="p-3 border border-gray-400">{t('work.startDate')}</th>
                                <th className="p-3 border border-gray-400">{t('work.endDate')}</th>
                                <th className="p-3 border border-gray-400">{t('common.completionDate')}</th>
                                <th className="p-3 border border-gray-400">Certificate</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="10" className="p-4">Loading...</td></tr>
                            ) : items.length === 0 ? (
                                <tr><td colSpan="10" className="p-4 text-gray-500">No completed works found</td></tr>
                            ) : (
                                items.map((item, idx) => (
                                    <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                                        <td className="p-3 border border-gray-300">{idx + 1}</td>
                                        <td className="p-3 border border-gray-300 text-left font-medium text-blue-900">{item.workTitle}</td>
                                        <td className="p-3 border border-gray-300">{item.tenderId}</td>
                                        <td className="p-3 border border-gray-300">{item.workOrderNo}</td>
                                        <td className="p-3 border border-gray-300">{item.duration}</td>
                                        <td className="p-3 border border-gray-300">{item.workOrderDate}</td>
                                        <td className="p-3 border border-gray-300">{item.workStartDate}</td>
                                        <td className="p-3 border border-gray-300">{item.workEndDate}</td>
                                        <td className="p-3 border border-gray-300 font-bold text-gray-700">{item.completeDate}</td>
                                        <td className="p-3 border border-gray-300">
                                            {item.fileLocation ? (
                                                <div className="bg-gray-50 p-2 rounded border border-dashed border-gray-400">
                                                    <a 
                                                        href={resolveMediaUrl(item.fileLocation)} 
                                                        target="_blank" 
                                                        rel="noreferrer" 
                                                        className="text-blue-600 underline text-[11px] font-bold break-all block leading-tight"
                                                    >
                                                        {item.fileName}
                                                    </a>
                                                </div>
                                            ) : "-"}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </PageFade>
    );
};

export default CompletionAlertDetailsPage;